import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

/**
 * Reads and updates whether a conversation attribute must be filled before a
 * conversation can be resolved. The list is the same account setting managed
 * from the Conversation Workflow page.
 */
export function useRequiredOnResolve() {
  const { t } = useI18n();
  const { currentAccount, accountId, updateAccount } = useAccount();
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  const isAvailable = computed(() =>
    isFeatureEnabledonAccount.value(
      accountId.value,
      FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES
    )
  );

  const requiredKeys = computed(
    () => currentAccount.value?.settings?.conversation_required_attributes || []
  );

  const isRequired = attributeKey => requiredKeys.value.includes(attributeKey);

  const setRequired = async (attributeKey, required) => {
    if (isRequired(attributeKey) === required) return;

    const keys = required
      ? [...requiredKeys.value, attributeKey]
      : requiredKeys.value.filter(key => key !== attributeKey);

    try {
      await updateAccount(
        { conversation_required_attributes: keys },
        { silent: true }
      );
    } catch (error) {
      useAlert(t('ATTRIBUTES_MGMT.REQUIRED_ON_RESOLVE.SAVE_ERROR'));
    }
  };

  return { isAvailable, isRequired, setRequired };
}
